import React from "react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js/auto';

import { Pie } from 'react-chartjs-2';
import { CommonUtilities } from "commonUtils";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart(chartPassedData: any) {

  const pieData = {
    labels: ['Red', 'Blue', 'Yellow', 'Green'],
    datasets: [
      {
        label: 'Votes',
        data: [12, 19, 7, 14],
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0'
        ],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  return (
    <div>
      {chartPassedData?.chartPassedData?.data?.length > 0 && <div style={CommonUtilities.parseStyleString(chartPassedData?.style)}>
        <Pie options={chartPassedData.chartPassedData.options} data={chartPassedData.chartPassedData.data} />
      </div>}

      {chartPassedData?.chartPassedData?.data?.length == 0 && <span className="text-center text-bold ws-12 mtl grey"> Not actioned. </span>}


    </div>
  )
}


/*import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-3';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      label: '# of Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

export default function App() {
  return <Pie data={data} />;
}

export default function App() {
  return <></>;
}*/